import Wrapper from "../../components/UI/wrapper";
import styles from "./index.module.css";
import KidsArtFestLogo from "../../assets/images/kids_art_fest_logo.svg";
import { Link } from "react-router-dom";
import UserIcon from "../../icons/profile.png";
import UsersIcon from "../../icons/audience.png";
import { useRef, useState } from "react";
import Logo from "../../assets/images/kids_art_fest_logo_3.png";
import Loading from "../../components/loading";
import uifThumb from '../../assets/images/uif_thumb.png'
import playButton from '../../assets/images/play-button.png'

const HomeTest = () => {
    const [showVideo, setShowVideo] = useState(false)
    const videoRef = useRef()

    const playVideo = () => {
        setShowVideo(prev => !prev)
        const video = videoRef.current;
        video?.play()
        if (video.requestFullscreen) {
            video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen(); // Safari
        } else if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen(); // Firefox
        } else if (video.msRequestFullscreen) {
            video.msRequestFullscreen(); // IE/Edge
        }
    }

    return (
        <>
            <main className={styles["back"]}>
                <Wrapper>
                    <div className={styles["hero"]}>
                        <div className={styles["hero_content"]}>
                            <h1>
                                {/* Ümummilli lider Heydər Əliyevin <br /> 100 illiyinə həsr edilən{" "}
              <br /> */}
                                Uşaq İncəsənət Festivalı  <br />
                                {/* <span style={{ fontWeight: 200, width: "100%", textAlign: "center" }}>2025</span> */}
                            </h1>
                            <div className={styles["buttons"]}>
                                {/* <Link to={"/registration"}>Qeydiyyat</Link> */}
                                <Link to="/registration-check">
                                    Nəticələri yoxla
                                </Link>
                            </div>
                            {/* <div className={styles["video_container"]}>
                                <p className={styles["video_title"]}>Təlimat videosu</p>
                                <video
                                    ref={videoRef}
                                    controls
                                    src="https://data.culture.az/storage/uif/2025/download/Master%20Final%20Update.mp4"
                                    poster={uifThumb}
                                    autoPlay={false}
                                    style={{ display: showVideo ? 'flex' : 'none' }}
                                />
                            </div>
                            {!showVideo &&
                                <div className={styles["thumb_container"]} onClick={playVideo}>
                                    <img src={uifThumb} />
                                    <button className={styles["play_button"]}>
                                        <img src={playButton} />
                                    </button>
                                </div>
                            } */}
                        </div>
                        <div className={styles["logo"]}>
                            <img src={Logo} alt="" />
                        </div>
                    </div>
                </Wrapper>
            </main>
        </>
    );
};
export default HomeTest;
